export default __webpack_public_path__ + "static/media/resync.2186e4bc.png";